function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { cloneUserSession } from 'invision-core/src/components/session/authentication.actions';
import { EnvironmentSettingNameSelector } from 'invision-core/src/components/environment/environment.selectors';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { CustomWidgetHostedUrlBaseSelector } from 'invision-core/src/components/customWidget/custom.widget.selectors';
import { STATUSES as CUSTOM_WIDGET_STATUSES } from 'invision-core/src/components/customWidget/custom.widget.constants';
import { CustomWidgetContainer } from 'invision-core/src/components/customWidget/custom.widget.container';
import { isApiEvent as isCustomWidgetApiEvent } from 'invision-core/src/components/customWidget/custom.widget.helpers';
import { UserSecurityContextSelector } from 'invision-core/src/components/session/session.selectors';
import LocaleKeys from '../../../locales/keys';
import { CurrentCustomerIdSelector, CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import { retrieveCustomer } from '../../../reducers/actions/customer.actions';
import { searchServices } from '../../../reducers/actions/services.actions';
import { CustomWidgetHasApiIntegrationSelector, CustomWidgetIsErroredSelector, CustomWidgetIsExpandedSelector, CustomWidgetIsLoadingSelector, CustomWidgetSelector } from '../../../reducers/selectors/custom.widgets.selectors';
import { initCustomWidget, setCustomWidgetHeight, setCustomWidgetStatus } from '../../../reducers/actions/custom.widgets.actions';
var WIDGET_ELEMENT_ID_PREFIX = 'custom-page';
var CustomPageController = /*#__PURE__*/function () {
  function CustomPageController($ngRedux, $sce, $state, $timeout) {
    _classCallCheck(this, CustomPageController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $sce: $sce,
      $state: $state,
      $timeout: $timeout,
      LocaleKeys: LocaleKeys,
      widget: null
    });
  }
  return _createClass(CustomPageController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentBusinessUnit: CurrentBusinessUnitSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentUserContext: UserSecurityContextSelector(store),
          customPage: CustomWidgetSelector(_this.pageData.Id)(store),
          customPageHasApiIntegration: CustomWidgetHasApiIntegrationSelector(_this.pageData.Id)(store),
          customPageHostedUrlBase: CustomWidgetHostedUrlBaseSelector(store),
          customPageIsErrored: CustomWidgetIsErroredSelector(_this.pageData.Id)(store),
          customPageIsExpanded: CustomWidgetIsExpandedSelector(_this.pageData.Id)(store),
          customPageIsLoading: CustomWidgetIsLoadingSelector(_this.pageData.Id)(store),
          environmentName: EnvironmentSettingNameSelector(store)
        };
      };
      var controllerActions = {
        cloneUserSession: cloneUserSession,
        initCustomWidget: initCustomWidget,
        retrieveCustomer: retrieveCustomer,
        searchServices: searchServices,
        setCustomWidgetHeight: setCustomWidgetHeight,
        setCustomWidgetStatus: setCustomWidgetStatus
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.actions = actions;
        _this.state = state;
      });
      this.actions.initCustomWidget({
        height: '100%',
        id: this.pageData.Id,
        integrationTypeId: this.pageData.IntegrationTypeId,
        isExpanded: true,
        statusId: CUSTOM_WIDGET_STATUSES.processing
      });
      if (this.state.customPageHasApiIntegration && this.state.customPageIsExpanded) {
        this.$timeout(function () {
          _this.initCustomPageWithApiIntegration();
        });
      } else if (!this.state.customPageHasApiIntegration) {
        this.iframeUrl = this.$sce.trustAsResourceUrl(this.pageData.URL.startsWith('http') ? this.pageData.URL : "https://".concat(this.pageData.URL));

        // events for when a message is received from the custom page
        this.receivePageDataEvent = function (evt) {
          if (!isCustomWidgetApiEvent(evt) && _this.iframeUrl) {
            var urlElement = new URL(_this.iframeUrl);
            if (evt.origin === urlElement.origin) {
              var data = null;
              try {
                data = JSON.parse(evt.data);
              } catch (e) {
                data = evt.data;
              }

              // start parsing data with url as a required to differentiate between listeners
              if (_typeof(data) === 'object' && (data.url === urlElement.href || data.url === _this.pageData.URL)) {
                if (!isNaN(data.height)) {
                  _this.actions.setCustomWidgetHeight({
                    id: _this.pageData.Id,
                    height: data.height
                  });
                }
              }
            }
          }
        };

        // listen for messages from the widget
        if (window.addEventListener) {
          window.addEventListener('message', this.receivePageDataEvent, false);
        } else {
          // support for IE8
          window.attachEvent('onmessage', this.receivePageDataEvent);
        }
        this.sendConfiguredPageData = JSON.stringify({
          SubscriberId: this.pageData.SendSubscriberId ? this.state.currentCustomer.Id : undefined,
          SubscriberExternalReferenceId: this.pageData.SendSubscriberExternalReferenceId ? this.state.currentCustomer.ExternalReference : undefined,
          AgentId: this.pageData.SendAgentId ? this.state.currentUserContext.Id : undefined,
          AgentRole: this.pageData.SendAgentRole ? this.state.currentUserContext.Roles : undefined
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.receivePageDataEvent) {
        window.removeEventListener('message', this.receivePageDataEvent, false);
      }
      if (this.widget && this.widget.disconnect) {
        this.widget.disconnect();
      }
      this.disconnect();
    }
  }, {
    key: "iframeOnLoadCallback",
    value: function iframeOnLoadCallback() {
      this.actions.setCustomWidgetStatus({
        id: this.pageData.Id,
        statusId: CUSTOM_WIDGET_STATUSES.idle
      });
    }
  }, {
    key: "iframeOnFailCallback",
    value: function iframeOnFailCallback() {
      this.actions.setCustomWidgetStatus({
        id: this.pageData.Id,
        statusId: CUSTOM_WIDGET_STATUSES.errored
      });
    }
  }, {
    key: "initCustomPageWithApiIntegration",
    value: function initCustomPageWithApiIntegration() {
      var _this3 = this;
      return CustomWidgetContainer.call(this, {
        actions: {
          boundCloneUserSession: {
            enumerable: false,
            value: this.actions.cloneUserSession
          },
          boundRetrieveCustomer: {
            enumerable: false,
            value: this.actions.retrieveCustomer
          },
          boundSearchServices: {
            enumerable: false,
            value: this.actions.searchServices
          },
          boundSetCustomWidgetStatus: {
            enumerable: false,
            value: this.actions.setCustomWidgetStatus
          }
        },
        container: angular.element("#".concat(WIDGET_ELEMENT_ID_PREFIX, "-").concat(this.pageData.Id))[0],
        data: {
          businessUnit: {
            id: this.state.currentBusinessUnit.id,
            name: this.state.currentBusinessUnit.name,
            systemId: this.state.currentBusinessUnit.systemId
          },
          customerId: this.state.currentCustomerId,
          environment: this.state.environmentName,
          user: {
            id: this.state.currentUserContext.Id,
            roles: this.state.currentUserContext.Roles
          },
          widgetId: this.pageData.Id
        },
        methods: {
          /**
           * Disconnect the container and widget.
           * @returns {void}
           */
          disconnect: function disconnect() {
            // Remove the iFrame element and destroy any `message` event listeners
            if (this.widget && this.widget.disconnect) {
              this.widget.disconnect();
            }
          },
          /**
           * Handle an encountered error.
           * @param {Error} error - Error encountered.
           *
           * @returns {Promise.<Error>} Promise object that _resolves_ to the provided error to support chaining.
           */
          handleError: function handleError(error) {
            var _this2 = this;
            return new Promise(function (resolve) {
              _this2.actions.setCustomWidgetStatus({
                id: _this2.pageData.Id,
                statusId: CUSTOM_WIDGET_STATUSES.errored
              });
              resolve(error);
            });
          }
        },
        state: this.$state,
        url: "".concat(this.state.customPageHostedUrlBase, "/").concat(this.pageData.Id, "/index.html")
      }).then(function (instance) {
        _this3.widget = instance;
        if (_this3.widget && _this3.widget.api && _this3.widget.api.log) {
          _this3.widget.api.log('Message sent from widget container using the example widget\'s custom `log` method...');
        }
        return Promise.resolve(instance);
      }).catch(function (error) {
        _this3.actions.setCustomWidgetStatus({
          id: _this3.pageData.Id,
          statusId: CUSTOM_WIDGET_STATUSES.errored
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: "reloadIframe",
    value: function reloadIframe() {
      var _this4 = this;
      var container = angular.element("#".concat(WIDGET_ELEMENT_ID_PREFIX, "-").concat(this.pageData.Id))[0];
      if (container && container.hasChildNodes()) {
        while (container.firstChild) {
          container.removeChild(container.firstChild);
        }
      }
      this.actions.setCustomWidgetStatus({
        id: this.pageData.Id,
        statusId: CUSTOM_WIDGET_STATUSES.processing
      });
      if (this.state.customPagHasApiIntegration) {
        this.$timeout(function () {
          _this4.initCustomPageWithApiIntegration();
        });
      }
    }
  }]);
}();
export default {
  template: require('./custom.page.html'),
  bindings: {
    currentCustomer: '<',
    currentUserContext: '<',
    pageData: '<'
  },
  controller: CustomPageController,
  controllerAs: 'ctrl'
};